import React from 'react';
import { Card, Col, Row } from 'antd';
import {
    ShoppingCartOutlined,
    UserOutlined,
    DollarOutlined,
    RiseOutlined,
} from '@ant-design/icons';

function Dashboard() {
    const stats = [
        {
            title: 'Bugungi sotuvlar',
            value: 12500000,
            prefix: '',
            suffix: ' so\'m',
            icon: <ShoppingCartOutlined />,
            color: 'var(--primary)',
            trend: '+12%',
        },
        {
            title: 'Jami mijozlar',
            value: 1847,
            icon: <UserOutlined />,
            color: 'var(--success)',
            trend: '+5%',
        },
        {
            title: 'O\'rtacha buyurtma',
            value: 285000,
            prefix: '',
            suffix: ' so\'m',
            icon: <DollarOutlined />,
            color: 'var(--warning)',
            trend: '+8%',
        },
        {
            title: 'Sotuv o\'sishi',
            value: 23,
            suffix: '%',
            icon: <RiseOutlined />,
            color: 'var(--info)',
            trend: '+3%',
        },
    ];

    return (
        <div className="animate-fade-in">
            <h2 style={{
                fontSize: '24px',
                fontWeight: 600,
                color: 'var(--text-primary)',
                marginBottom: '24px',
            }}>
                Dashboard
            </h2>
            
            <Row gutter={[24, 24]}>
                {stats.map((stat, index) => (
                    <Col xs={24} sm={12} lg={6} key={index}>
                        <Card
                            className="hover-lift"
                            style={{
                                borderRadius: 'var(--radius-lg)',
                                border: '1px solid var(--border)',
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                            }}>
                                <div>
                                    <div style={{
                                        fontSize: '13px',
                                        color: 'var(--text-muted)',
                                        marginBottom: '8px',
                                        fontWeight: 500,
                                    }}>
                                        {stat.title}
                                    </div>
                                    <div style={{
                                        fontSize: '28px',
                                        fontWeight: 700,
                                        color: 'var(--text-primary)',
                                        lineHeight: 1.2,
                                    }}>
                                        {stat.prefix}{typeof stat.value === 'number' ? stat.value.toLocaleString() : stat.value}{stat.suffix}
                                    </div>
                                    <div style={{
                                        fontSize: '12px',
                                        color: 'var(--success)',
                                        marginTop: '8px',
                                        fontWeight: 500,
                                    }}>
                                        {stat.trend} o'tgan oydan
                                    </div>
                                </div>
                                <div style={{
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: 'var(--radius-md)',
                                    backgroundColor: stat.color + '15',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '20px',
                                    color: stat.color,
                                }}>
                                    {stat.icon}
                                </div>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
            
            <Row gutter={[24, 24]} style={{ marginTop: '24px' }}>
                <Col xs={24} lg={16}>
                    <Card
                        title="Sotuvlar grafigi"
                        style={{
                            borderRadius: 'var(--radius-lg)',
                            border: '1px solid var(--border)',
                        }}
                    >
                        <div style={{
                            height: '300px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'var(--text-muted)',
                        }}>
                            Grafik joyi
                        </div>
                    </Card>
                </Col>
                <Col xs={24} lg={8}>
                    <Card
                        title="So'nggi buyurtmalar"
                        style={{
                            borderRadius: 'var(--radius-lg)',
                            border: '1px solid var(--border)',
                        }}
                    >
                        <div style={{
                            height: '300px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'var(--text-muted)',
                        }}>
                            Buyurtmalar ro'yxati
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default Dashboard;